function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Filter } from '@finect/tabular-icons/filter';
import { debounce } from '@finect/front-utils/debounce';
import { cancelablePromise } from '@finect/front-utils/cancelablePromise';
import { dataLayer } from '@finect/front-gtm';
import { Alert } from '../../Alert';
import { OverflowMenu } from '../../OverflowMenu';
import { CheckboxItems, Controls } from '../../Filter/CheckboxFilter/partials';
import { getInitialValue } from '../../Filter/CheckboxFilter/utils';
import { SearchInput } from '../SearchInput';
import { Inner, PlaceholderBlock } from './partials';
import { isMobile, showHint } from './utils';
var availableIcons = {
  filter: Filter
};
export var MultiSelect = function (_React$Component) {
  _inherits(MultiSelect, _React$Component);
  var _super = _createSuper(MultiSelect);
  function MultiSelect() {
    var _this;
    _classCallCheck(this, MultiSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "pendingPromises", []);
    _defineProperty(_assertThisInitialized(_this), "debouncedSearchAction", debounce(_this.props.searchAction ? _this.props.searchAction : function () {}, 400));
    _defineProperty(_assertThisInitialized(_this), "child", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      search: '',
      prevValue: _toConsumableArray(_this.props.value),
      open: isMobile() || !_this.props.alwaysOpen ? _this.props.opened || false : true,
      actionDisabled: true,
      searchResults: [],
      selectedSearchResults: [],
      searchFetching: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleCheckboxChange", function (event) {
      var _event$target = event.target,
        checked = _event$target.checked,
        name = _event$target.name;
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        multiple = _this$props.multiple,
        value = _this$props.value,
        max = _this$props.max,
        closeOnChange = _this$props.closeOnChange;
      var baseValue = multiple ? _toConsumableArray(value) : [];
      var newValue = checked ? [].concat(_toConsumableArray(baseValue), [name]) : baseValue.filter(function (item) {
        return item !== name;
      });
      dataLayer({
        id: 'FiEvent',
        type: 'fiEvent',
        params: {
          category: 'Interaction',
          action: name,
          label: "checkbox-".concat(checked ? 'select' : 'deselect')
        }
      });
      if (!((max || 0) > 0) || newValue.length < value.length || max && newValue.length <= (max || 0)) {
        _this.setState(function (state) {
          var allResults = [].concat(_toConsumableArray(state.selectedSearchResults), _toConsumableArray(state.searchResults));
          return _objectSpread(_objectSpread({}, state), {}, {
            actionDisabled: false,
            selectedSearchResults: newValue.map(function (id) {
              return allResults.find(function (item) {
                return item.id === id;
              });
            }).filter(function (item) {
              return Boolean(item);
            })
          });
        });
        onChange(newValue);
        if (!multiple && closeOnChange) {
          _this.handleReturn();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "removePendingPromise", function (promise) {
      return _this.pendingPromises = _this.pendingPromises.filter(function (pendingPromise) {
        return pendingPromise !== promise;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "appendPendingPromise", function (promise) {
      return _this.pendingPromises = [].concat(_toConsumableArray(_this.pendingPromises), [promise]);
    });
    _defineProperty(_assertThisInitialized(_this), "processPromise", function (wrappedPromise) {
      _this.setState({
        searchFetching: true
      });
      wrappedPromise.promise.then(function (results) {
        _this.setState({
          searchResults: results,
          searchFetching: false
        });
      }).then(function () {
        _this.removePendingPromise(wrappedPromise);
      }).catch(function (errorInfo) {
        _this.setState({
          searchFetching: false
        });
        if (!errorInfo.isCanceled) {
          _this.removePendingPromise(wrappedPromise);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (event) {
      _this.setState({
        search: event.target.value,
        searchResults: []
      });
      if (_this.props.searchAction) {
        var debounced = debounce(_this.debouncedSearchAction, 300);
        _this.pendingPromises.map(function (promise) {
          return promise.cancel();
        });
        var wrappedPromise = cancelablePromise(debounced(event.target.value));
        _this.appendPendingPromise(wrappedPromise);
        _this.processPromise(wrappedPromise);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleEmptyAction", function () {
      _this.props.onChange([]);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.setState({
        prevValue: _toConsumableArray(_this.props.value),
        open: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (isMobile() || !_this.props.alwaysOpen) {
        _this.setState({
          prevValue: [],
          open: false,
          search: '',
          searchResults: []
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleReturn", function () {
      var _this$props2 = _this.props,
        onReturn = _this$props2.onReturn,
        value = _this$props2.value;
      if (isMobile() || !_this.props.alwaysOpen) {
        _this.setState({
          open: false,
          search: '',
          searchResults: []
        });
        _this.child.close();
      }
      _this.setState({
        actionDisabled: true
      });
      onReturn && onReturn(value);
    });
    return _this;
  }
  _createClass(MultiSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        placeholder = _this$props3.placeholder,
        _this$props3$actionTe = _this$props3.actionText,
        actionText = _this$props3$actionTe === void 0 ? 'Aplicar' : _this$props3$actionTe,
        _this$props3$multiple = _this$props3.multiple,
        multiple = _this$props3$multiple === void 0 ? false : _this$props3$multiple,
        leadingIcon = _this$props3.leadingIcon,
        _this$props3$fullWidt = _this$props3.fullWidth,
        fullWidth = _this$props3$fullWidt === void 0 ? false : _this$props3$fullWidt,
        _this$props3$alwaysOp = _this$props3.alwaysOpen,
        alwaysOpen = _this$props3$alwaysOp === void 0 ? false : _this$props3$alwaysOp,
        _this$props3$hideCont = _this$props3.hideControls,
        hideControls = _this$props3$hideCont === void 0 ? false : _this$props3$hideCont,
        _this$props3$options = _this$props3.options,
        options = _this$props3$options === void 0 ? [] : _this$props3$options,
        _this$props3$reorderO = _this$props3.reorderOptions,
        reorderOptions = _this$props3$reorderO === void 0 ? true : _this$props3$reorderO,
        _this$props3$max = _this$props3.max,
        max = _this$props3$max === void 0 ? null : _this$props3$max;
      var _this$state = this.state,
        open = _this$state.open,
        search = _this$state.search,
        actionDisabled = _this$state.actionDisabled,
        selectedSearchResults = _this$state.selectedSearchResults,
        searchResults = _this$state.searchResults;
      var value = getInitialValue(this.props.value.map(function (id) {
        return {
          id: id,
          checked: true
        };
      }));
      var getCheckboxOptions = function getCheckboxOptions() {
        var selectedIds = selectedSearchResults.map(function (_ref) {
          var id = _ref.id;
          return id;
        });
        if (_this2.props.searchAction) {
          return [].concat(_toConsumableArray(options), _toConsumableArray(selectedSearchResults), _toConsumableArray(searchResults.filter(function (item) {
            return !selectedIds.includes(item.id);
          })));
        }
        var leadingOptions = options.filter(function (option) {
          return _this2.state.prevValue.includes(option.id);
        });
        var trailingOptions = options.filter(function (option) {
          return !_this2.state.prevValue.includes(option.id);
        });
        return reorderOptions ? [].concat(_toConsumableArray(leadingOptions), _toConsumableArray(trailingOptions)) : options;
      };
      var displayOptions = getCheckboxOptions();
      var chips = displayOptions.filter(function (item) {
        return _this2.props.value.includes(item.id);
      });
      var selectedQty = chips.length;
      var newPlaceholder = "".concat(placeholder || '').concat((max || 0) > 0 ? " (m\xE1ximo ".concat(max || 0, ")") : '');
      var maxIsFilled = (max || 0) > 0 && selectedQty >= (max || 0);
      var HandlerComponent = React.createElement("div", null, React.createElement(SearchInput, {
        loading: this.props.loading || this.state.searchFetching,
        chips: chips,
        showChips: !multiple,
        open: open,
        placeholder: newPlaceholder,
        withCount: selectedQty > 0,
        onRestoreAction: this.handleEmptyAction,
        qty: selectedQty,
        search: search,
        onChange: this.handleSearchChange
      }));
      return React.createElement(Inner, {
        fullWidth: fullWidth
      }, React.createElement(OverflowMenu, {
        fullWidth: fullWidth,
        alwaysOpen: alwaysOpen,
        display: "block",
        handlerComponent: HandlerComponent,
        open: open,
        ref: function ref(_ref2) {
          return _this2.child = _ref2;
        },
        onOpen: this.handleOpen,
        onClose: this.handleClose,
        leadingIcon: leadingIcon && availableIcons[leadingIcon] ? availableIcons[leadingIcon] : null
      }, React.createElement(CheckboxItems, {
        filterSearchResults: !this.props.searchAction,
        maxIsFilled: maxIsFilled,
        fullWidth: fullWidth,
        options: displayOptions,
        multiple: multiple,
        value: value,
        search: search,
        onCheckboxChange: this.handleCheckboxChange
      }), showHint(this.props, this.state) ? React.createElement(PlaceholderBlock, null, React.createElement(Alert, {
        size: "small",
        type: "info",
        withIcon: true
      }, this.props.searchHint)) : null, !hideControls && React.createElement(Controls, {
        actionText: actionText,
        restoreDisabled: true,
        actionDisabled: actionDisabled,
        onReturn: this.handleReturn
      })));
    }
  }]);
  return MultiSelect;
}(React.Component);